import { useEffect } from 'react';
import type { Experiments } from '@wix/yoshi-flow-editor';

type UseBfcacheNavigationResetParams = {
  navigationInitiatedBy?: string;
  resetNavigationInitiatedBy: () => void;
  experiments: Experiments;
};

export const useBfcacheNavigationReset = ({
  navigationInitiatedBy,
  resetNavigationInitiatedBy,
  experiments,
}: UseBfcacheNavigationResetParams) => {
  useEffect(() => {
    if (
      !experiments.enabled('specs.bookings.ResetNavigatingStatusOnServicePage')
    ) {
      return;
    }

    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted && navigationInitiatedBy) {
        resetNavigationInitiatedBy();
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [navigationInitiatedBy, resetNavigationInitiatedBy, experiments]);
};
